import { render, staticRenderFns } from "./index-tc.vue?vue&type=template&id=bc4a13fc&scoped=true"
import script from "./index-tc.vue?vue&type=script&lang=js"
export * from "./index-tc.vue?vue&type=script&lang=js"
import style0 from "./index-tc.vue?vue&type=style&index=0&id=bc4a13fc&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bc4a13fc",
  null
  
)

export default component.exports